import React, { FC } from 'react';
import { SlotComponentProps } from '../../types';
import { RecentViewedProducts } from 'modules/home/mobile/blocks';
import { LazyComponent } from 'components/LazyComponent';

export type RecentProductMobileSlotProps = SlotComponentProps<{}>;

export const RecentProductMobileSlot: FC<RecentProductMobileSlotProps> = () => {
  return <RecentViewedProducts />;
};

export const LazyRecentProductMobileSlot: FC<RecentProductMobileSlotProps> = (
  props,
) => {
  return (
    <LazyComponent>
      <RecentProductMobileSlot {...props} />
    </LazyComponent>
  );
};
